import contractManage from './contractManage';
import accountManage from './accountManage';
import contractGroupManage from './contractGroupManage';
import customer from './customer';
import homePage from './homePage';
import leadManage from './leadManage';
import customerVisitManage from './customerVisitManage';
import revenueForecast from './revenueForecast';
const config = {
    ...contractManage,
    ...accountManage,
    ...contractGroupManage,
    ...customer,
    ...homePage,
    ...leadManage,
    ...customerVisitManage,
    ...revenueForecast
};
export default config;
